/* global axios */
import ApiClient from './ApiClient';

class TasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  getByBoard(boardId) {
    return axios.get(this.url, { params: { board_id: boardId } });
  }

  reorder(positions) {
    return axios.post(`${this.url}/reorder`, { positions });
  }

  addAttachment(id, files) {
    const formData = new FormData();
    Array.from(files).forEach(file => {
      formData.append('task[attachments][]', file);
    });
    return axios.post(`${this.url}/${id}/add_attachment`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  removeAttachment(id, attachmentId) {
    return axios.delete(`${this.url}/${id}/attachments/${attachmentId}`);
  }

  getComments(taskId) {
    return axios.get(`${this.url}/${taskId}/comments`);
  }

  createComment(taskId, comment) {
    return axios.post(`${this.url}/${taskId}/comments`, { comment });
  }

  updateComment(taskId, id, comment) {
    return axios.patch(`${this.url}/${taskId}/comments/${id}`, { comment });
  }

  deleteComment(taskId, id) {
    return axios.delete(`${this.url}/${taskId}/comments/${id}`);
  }

  addMember(taskId, userId) {
    return axios.post(`${this.url}/${taskId}/members`, { user_id: userId });
  }

  removeMember(taskId, userId) {
    return axios.delete(`${this.url}/${taskId}/members/${userId}`);
  }

  watch(taskId) {
    return axios.post(`${this.url}/${taskId}/watch`);
  }

  unwatch(taskId) {
    return axios.delete(`${this.url}/${taskId}/watch`);
  }
}

export default new TasksAPI();
